<app-navbar></app-navbar>

<div *ngIf="loading" class="loader-box">
  <div class="loader"></div>
</div>

<div class="page-content">
  <div class="header"></div>

  <!-- Events -->
  <div id="events">
    <div class="card">
      <div class="card-body">
        <div class="next-serv-heading">
          <h4 class="">Sunday Celebration Services</h4>
        </div>

        <div class="row card-countdown hide">
          <div class="col-3 card bg-light">
            <div class="card-body">
              <h5 class="text-center ">{{countdown[0]}}</h5>
              <p class="text-center ">DAYS</p>
            </div>
          </div>
          <div class="col-3 card bg-light">
            <div class="card-body">
              <h5 class="text-center">{{countdown[1]}}</h5>
              <p class="text-center ">HOURS</p>
            </div>
          </div>
          <div class="col-3 card bg-light">
            <div class="card-body">
              <h5 class="text-center">{{countdown[2]}}</h5>
              <p class="text-center ">MINUTES</p>
            </div>
          </div>
          <div class="col-3 card bg-light">
            <div class="card-body">
              <h5 class="text-center">{{countdown[3]}}</h5>
              <p class="text-center ">SECONDS</p>
            </div>
          </div>
        </div>


        <h2 class="text-center mb-4 mt-5">UPCOMING EVENTS</h2>
        <div class="slider mt-4">
          <div class="slide">
            <div class="card events-slide">
              <img class="card-img-top" src="./../../assets/mission.png" alt="Card image">
              <div class="card-body">
                <h5 class="card-title">LATTER RAIN CONFERENCE</h5>
                <p class="card-text"><b>Date</b> TBD</p>
                <p class="card-text">This is a yearly conference organized by the church at local levels.
                  The HOLY SPIRIT and His gifts are the main focus during the conference. It takes place 2nd
                  week of March every year.
                </p>
              </div>
            </div>
          </div>

          <div class="slide">
            <div class="card events-slide">
              <img class="card-img-top" src="./../../assets/community.png" alt="Card image">
              <div class="card-body">
                <h5 class="card-title">NATIONAL DISCIPLES CONFERENCE</h5>
                <p class="card-text"><b>Date</b> TBD</p>
                <p class="card-text">This is an annually conference for all the members and its affiliate nationwide.
                  The main focus is on discipleship through bible studies, prayers and the infilling of the
                  HOLY SPIRIT. It takes place 3rd week in August every year.
                </p>
              </div>
            </div>
          </div>

          <div class="slide">
            <div class="card events-slide">
              <img class="card-img-top" src="./../../assets/conference.jpg" alt="Card image">
              <div class="card-body">
                <h5 class="card-title">DISCIPLES ENCOUNTER</h5>
                <p class="card-text"><b>Date</b> TBD</p>
                <p class="card-text">These are held on weekends for residential retreat where intense Bible studies
                  and prayer are made. There are Holy Spirit infilling sections, deliverance and healing sections
                  and waiting on the Lord for special sections.
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>


  <!-- About -->
  <div id="about">
    <div class="content-title mb-3">
      <h2 class="text-center">ABOUT THE CHURCH</h2>
    </div>

    <div class="card-deck">
      <div class="card">
        <div class="card-body">
          <h5 class="text-center ">Our Community</h5>
          <img class="about-img" src="./../../assets/community.png" alt="">
          <p>
            Christian Mission Dunamis, Inc. is a Charismatic Pentecostal church with over 50 branches in Ghana,
            West Africa. Most of these churches are in the 10/40 window of the world. 10/40 window is the most
            unevangelized regions of the eastern hemisphere, plus the European and African part of the Western
            Hemisphere. The 10/40 window concept highlights these three elements;
            <i>an area of the world with great poverty and low quality of life, combined with lack of access to
              Christian resources.
            </i>
          </p>
          <br>
          <p>
            The church is dynamic in evangelizing and establishing churches in towns and villages. We engage in
            the G12 concept of discipleship thus; <b>win, consolidate, disciple and send.</b>
            Apostle Dr. Waye- Onyina Stephen is the head pastor of Christian Mission Dunamis Inc. He is a man of
            proven ministry, conference speaker, church planter with signs and wonders following his ministry.
          </p>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <h5 class="text-center">Our Mission</h5>
          <img class="about-img" src="./../../assets/mission.png" alt="">
          <p>
            We proclaim the good news of the Kingdom of God by winning, consolidating, disciplining and sending
            as commanded by our Lord Jesus Christ in Matthew 28: 18-20.
            Members are trained to be leaders through the school of leaders and Destiny training school.
          </p>
          <br>
            <h6>OUR BELIEFS</h6>
            <ol>
              <li class="mb-1">
                We believe; there is one God, who is infinitely perfect, an eternal God who has revealed
                himself as the triune Godhead. Genesis 1:1, Matthew 3:16-17, Matthew 28:19 and 2nd Corinthians 13:14.
              </li>
              <li class="mb-1">
                Jesus Christ is true God and man. He was conceived by the Holy Spirit and born of the virgin Mary.
                He died on the cross, the just for the unjust, as a substitutionary sacrifice, and all who believe
                in Him are justified on the grounds of His blood. He arose from the dead according to the
                scriptures and will come again to establish His Kingdom of righteousness and peace.
              </li>
              <li class="mb-1">
                The Holy Spirit is a divine person, sent to indwell, guide, teach and empower the believer,
                and convict the world of sin, of righteousness and of judgement.
              </li>
              <li>
                The old and new testaments, inerrant as originally given, were verbally inspired by God and
                are a complete revelation of His will for the salvation of man. They constitute the divine
                and only rule of Christian faith and practice.
              </li>
            </ol>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Testimonials -->
<section id="testimonials" class="hide">

  <h2 class="text-center text-white">TESTIMONIALS</h2>

  <div id="testimonial" class="carousel slide" data-ride="carousel">

    <!-- Indicators -->
    <!-- <ul class="carousel-indicators">
      <li data-target="#testimonial" data-slide-to="0" class="active"></li>
      <li data-target="#testimonial" data-slide-to="1"></li>
      <li data-target="#testimonial" data-slide-to="2"></li>
    </ul> -->

    <!-- The slideshow -->
    <div class="carousel-inner">
      <div class="carousel-item active">
        <div class="caption">
          <h3>Testimonial 1</h3>
          <p>- Name here</p>
        </div>
      </div>
      <div class="carousel-item">
        <div class="caption">
          <h3>Testimonial 2</h3>
          <p>- Name here</p>
        </div>
      </div>
      <div class="carousel-item">
        <div class="caption">
          <h3>Testimonial 3</h3>
          <p>- Name here</p>
        </div>
      </div>
    </div>

    <!-- Left and right controls -->
    <!-- <a class="carousel-control-prev" data-slide="prev">
      <span class="carousel-control-prev-icon"></span>
    </a>
    <a class="carousel-control-next" data-slide="next">
      <span class="carousel-control-next-icon"></span>
    </a> -->

  </div>
</section>



<app-footer></app-footer>
